/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Radio from '@material-ui/core/Radio';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  icon: {
    borderRadius: '50%',
    width: '1.2rem',
    height: '1.2rem',
    backgroundColor: theme.palette.white,
    '&:after': {
      display: 'block',
      width: '1.2rem',
      height: '1.2rem',
      borderRadius: '50%',
      border: `1px solid ${theme.palette.lightBorder}`,
      backgroundImage: `radial-gradient(${theme.palette.checkboxUnchecked},${theme.palette.checkboxUnchecked}
       60%)`,
      content: '""',
    },
    'input ~ &': {
      backgroundColor: theme.palette.white,
      '&:after': {
        display: 'block',
        width: '1.2rem',
        height: '1.2rem',
        borderRadius: '50%',
        backgroundImage: `radial-gradient(${theme.palette.checkboxUnchecked},${theme.palette.checkboxUnchecked} 60%,transparent 32%)`,
        content: '""',
      },
    },
    'input:hover ~ &': {
      '&:after': {
        backgroundImage: `radial-gradient(${theme.palette.darkGray},${theme.palette.darkGray} 60%,transparent 32%)`,
      },
    },
    'input:hover:disabled ~ &': {
      '&:after': {
        backgroundImage: `radial-gradient(${theme.palette.lightGray},${theme.palette.lightGray} 60%,transparent 32%)`,
      },
    },
    'input:focus ~ &': {
      backgroundColor: theme.palette.white,
      '&:after': {
        display: 'block',
        width: '1.2rem',
        height: '1.2rem',
        borderRadius: '50%',
        border: `3px solid ${theme.palette.primary.main}`,
        backgroundImage: `radial-gradient(${theme.palette.darkGray},${theme.palette.darkGray} 60%,transparent 32%)`,
        content: '""',
      },
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      backgroundColor: theme.palette.white,
      '&:after': {
        display: 'block',
        width: '1.2rem',
        height: '1.2rem',
        borderRadius: '50%',
        border: `1px solid ${theme.palette.disabledCheckbox}`,
        backgroundImage: `radial-gradient(${theme.palette.lightGray},${theme.palette.lightGray} 60%,transparent 32%)`,
        content: '""',
      },
    },
  },
  checkedIcon: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    '&:before': {
      display: 'block',
      width: '1.2rem',
      height: '1.2rem',
      backgroundImage: `radial-gradient(${theme.palette.white},${theme.palette.white} 19%,transparent 32%)`,
      content: '""',
    },
  },
}));

export default function CustomRadio(props) {
  const classes = useStyles();
  return (
    <Radio
      color={props.color || 'primary'}
      icon={<span className={classes.icon} />}
      checkedIcon={<span className={classes.checkedIcon} />}
      {...props}
    />
  );
}
